import React from 'react';
import { NavLink, NavLinkProps, useLocation } from 'react-router-dom';
import * as css from './tabs.module.scss';
import classNames from 'classnames';

interface TabProps
  extends React.PropsWithoutRef<NavLinkProps>,
    React.RefAttributes<HTMLAnchorElement> {
  id?: string;
  className?: string;
  disabled?: boolean;
}

interface TabsProps {
  className?: string;
}

export const Tab: React.FC<React.PropsWithChildren<TabProps>> = ({
  id,
  to,
  className,
  disabled,
  children,
  ...props
}) => {
  const location = useLocation();
  return (
    <NavLink
      {...props}
      id={id}
      to={disabled ? location : to}
      className={({ isActive }) =>
        classNames(
          css.tab,
          isActive && css.active,
          disabled && css.deactivated,
          className,
        )
      }
    >
      {children}
    </NavLink>
  );
};

export const Tabs: React.FC<React.PropsWithChildren<TabsProps>> = ({
  className,
  children,
}) => <div className={classNames(css.tabs, className)}>{children}</div>;
